// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { server16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-server': IconServer;
    }
}

/**
 * The icon component for the 'server' icon
 */
export class IconServer extends IconSvg {
    public constructor() {
        super(server16X16);
    }
}

registerIconSvg('icon-server', IconServer);
export const iconServerTag = 'nimble-icon-server';
